export const iconFontAwesomeDevicesHardwareWalkieTalkie = (
	<i className="fa-solid fa-walkie-talkie"></i>
);
